import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { GateWayService } from '../../../services/gateway-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-manage-child-org-view',
  templateUrl: './manage-child-org-view.component.html',
  styleUrls: ['./manage-child-org-view.component.scss','../../platform-color/platform-color.scss']
})
export class ManageChildOrgViewComponent implements OnInit {
  name: string;
  childOrg: any;
  upload = environment.URL_UPLOAD;
  org_id: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private GateWayService: GateWayService
  ) { 
    this.name = this.route.snapshot.paramMap.get("name");
    this.route.queryParams
    .subscribe(params => {
      this.org_id = params.org_id;
    })
  }

  ngOnInit() {
    this.spinner.show();
    this.GateWayService.getChildOrgByName(this.name).subscribe(res=>{
      this.childOrg = res.data.find(child=> child.org_id == this.org_id);
      this.spinner.hide();
    })
  }

  back(){
    this.router.navigateByUrl("/homepage");
  }
}
